import React, {Fragment} from 'react';

import AggregateShellComponent from "../../../../gd-modules/common/aggregate/aggregate-shell";

export default function AggregatePercentage(options, params, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const decimalPlaces = params ? params.decimalPlaces : 0
    const value = isValid ? gd.utils.roundToDecimals(props.value, decimalPlaces) : null;

    let noDataLabel;
    switch (props.aggregateFunction) {
        case gd.const.aggregate.type.SUM:
            noDataLabel = '0';
            break;
        default:
            noDataLabel = gd.const.aggregate.label[props.aggregateFunction];
            break;
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} hint={value + "%"} {...props}>
            {isValid &&
            <Fragment>
                <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>
                <div className="aggregate-value aggregate-number">{value} %</div>
            </Fragment>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}